import {
  CHECK_AUTH_TYPE,
  CHECK_AUTH_TYPE_SUCCESSFUL,
  CHECK_AUTH_TYPE_FAILED,
} from "./actionTypes"

const initialState = {
  authTypeError: null,
  message: null,
  loading: false,
  authType: null,
}

const authType = (state = initialState, action) => {
  switch (action.type) {
    case CHECK_AUTH_TYPE:
      state = {
        ...state,
        loading: true,
        authTypeError: null,
      }
      break
    case CHECK_AUTH_TYPE_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        authType: action.payload,
        authTypeError: null,
      }
      break
    case CHECK_AUTH_TYPE_FAILED:
      state = {
        ...state,
        authType: null,
        loading: false,
        authTypeError: action.payload,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default authType
